module.exports = "images/doc-country-add.04545989ec446475b5f9f294546ffa95.png";